import { render, staticRenderFns } from "./TrendingHashtagsWidget.vue?vue&type=template&id=13d7a50a&scoped=true&"
import script from "./TrendingHashtagsWidget.vue?vue&type=script&lang=js&"
export * from "./TrendingHashtagsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrendingHashtagsWidget.vue?vue&type=style&index=0&id=13d7a50a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7a50a",
  null
  
)

export default component.exports